import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
`

export const Content = styled.div`
  cursor: inherit;
`

export const Badges = styled.div`
  position: absolute;
  top: ${props => props.theme.spacing.sp8};
  right: ${props => props.theme.spacing.sp8};
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  pointer-events: none;
`
